<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-file-input ref="myFiles" accept="image/*" label="File input" @change="previewImage" />

        <v-row>
          <v-col>
            <v-btn v-if="previewUrl" color="blue-grey" class="ma-2 white--text" @click="onUpload">
              Upload
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            {{ picture }}
            {{thumb(picture, '_50x50')}}
            <!--  <v-img v-if="picture" :lazy-src="thumb(picture, '_50x50')" :src="picture" /> -->
          </v-col>
          <v-col>
            <v-progress-circular
              :rotate="360"
              :size="100"
              :width="15"
              :value="uploadValue"
              color="teal"
            >
              <span v-if="uploadValue == 0">Ready...</span>
              <span v-if="uploadValue > 0 && uploadValue < 100">{{uploadValue.toFixed() + "%"}}</span>
              <span v-if="uploadValue == 100">Done</span>
            </v-progress-circular>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-img v-if="previewUrl" :src="previewUrl" max-height="300" max-width="300" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import { db } from "../main";
import firebase from "firebase";
//import { uuid } from 'vue-uuid';

export default {
  filters: {
    thumb2: function(url, suffix) {
      if (url) {
        //  console.log(url);
        if (!suffix) {
          suffix = "_100x100";
        }

        var filename = url
          .substring(url.lastIndexOf("%2F") + 3)
          .split("/")
          .pop()
          .split("?")[0];
        var ext = filename.split(".").pop();
        var name = filename
          .split(".")
          .slice(0, -1)
          .join(".");
        return url.replace(filename, "thumbs%2F" + name + suffix + "." + ext);
      }
    }
  },
  created() {},
  data: () => ({
    title: "Image Upload",

    imageData: null,
    picture: null,
    uploadValue: 0,
    previewUrl: null
  }),

  methods: {
    thumb(url, suffix) {
      if (url) {
        // console.log(url);
        if (!suffix) {
          suffix = "_50x50";
        }

        var filename = url
          .substring(url.lastIndexOf("%2F") + 3)
          .split("/")
          .pop()
          .split("?")[0];
        var ext = filename.split(".").pop();
        var name = filename
          .split(".")
          .slice(0, -1)
          .join(".");
        return url.replace(filename, "thumbs%2F" + name + suffix + "." + ext);
      }
    },
    previewImage(event) {
      //console.log(event);
      this.uploadValue = 0;
      this.picture = null;
      this.previewUrl = null;
      if (event) {
        this.imageData = event;
        this.previewUrl = URL.createObjectURL(this.imageData);
        //console.log(this.imageData.name.split(".").pop());

        //console.log(newName);
      }
    },
    onUpload() {
      var that = this;
      this.picture = null;
      const storageRef = firebase.storage().ref();
      const imagesRef = storageRef.child("test");
      const uuid = this.$uuid.v4();
      const ext = this.imageData.name.split(".").pop();
      const newName = uuid + "." + ext;
      const suffix = "_1000x1000";
      const smallName = uuid + suffix + "." + ext;
      const imageRef = imagesRef.child(`${newName}`);

      var task = imageRef.put(this.imageData);

      task.on(
        `state_changed`,
        snapshot => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          //console.log(error.message);
        },
        () => {
          task.snapshot.ref.getDownloadURL().then(url => {
            var finished = false;
            var that = this;
            var url = 

            function wait() {
              firebase
                .storage()
                .ref("test/thumbs/" + smallName)
                .getDownloadURL()
                .then(function(smallurl) {
                  //console.log("url", url);
                  console.log("Got the url");
                  finished = true;

                  return;
                })
                .catch(function(error) {
                  console.log("error");
                });

              if (!finished) {
                //upload is not finished
                console.log("waiting");
                setTimeout(wait, 1000);
              } else {
                //upload is finished
                // console.log("finished = true");
                console.log("finished", finished);

                that.uploadValue = 100;
                that.picture = url;
                console.log(this.picture);

                that.previewUrl = null;
                that.imageData = null;
              }
            }

            wait();
            //setTimeout(() => (this.picture = url), 2500);
          });
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
